(() => {
  'use strict';

  const dialog = document.querySelector('[data-media-save-dialog]');
  const main = document.getElementById('MainContent');
  if (!dialog || !main || typeof dialog.showModal !== 'function') return;

  const title = dialog.querySelector('[data-media-save-title]');
  const download = dialog.querySelector('[data-media-save-download]');
  const open = dialog.querySelector('[data-media-save-open]');
  const close = dialog.querySelector('[data-media-save-close]');
  const strings = window.LionTheme?.strings || {};
  let press;
  let suppressedHost;
  let suppressUntil = 0;

  const supportedUrl = (value) => {
    if (!value) return null;
    try {
      const url = new URL(value, window.location.href);
      const host = url.hostname.toLowerCase();
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
      if (url.origin !== window.location.origin
        && host !== 'cdn.shopify.com'
        && !host.endsWith('.shopifycdn.com')
        && !host.endsWith('.myshopify.com')) return null;
      return url;
    } catch (error) {
      return null;
    }
  };

  const imageUrl = (image) => {
    const zoom = image.closest('[data-media-zoom-open]')?.dataset.zoomSrc;
    const largest = image.srcset?.split(',').map((entry) => entry.trim().split(/\s+/)[0]).at(-1);
    const url = supportedUrl(zoom || largest || image.currentSrc || image.src);
    if (url && url.pathname.includes('/cdn/') && url.searchParams.has('width')) {
      url.searchParams.set('width', '2400');
    }
    return url;
  };

  const videoUrl = (video) => {
    const sources = Array.from(video.querySelectorAll('source'))
      .filter((source) => source.type === 'video/mp4' || /\.mp4(?:\?|$)/i.test(source.src));
    sources.sort((a, b) => {
      const quality = (source) => Number(source.src.match(/(\d{3,4})p/i)?.[1] || 0);
      return quality(a) - quality(b);
    });
    return supportedUrl(sources.at(-1)?.src || (/\.mp4(?:\?|$)/i.test(video.currentSrc) ? video.currentSrc : video.src));
  };

  const cancelPress = () => {
    if (press?.timer) window.clearTimeout(press.timer);
    press = undefined;
  };

  const mediaFromTarget = (target) => {
    if (!(target instanceof Element)) return null;
    if (target.closest('[data-media-previous], [data-media-next], [data-media-zoom-close]')) return null;
    const galleryItem = target.closest('[data-media-item]');
    if (galleryItem) return galleryItem.querySelector('video.product-media__asset, img.product-media__asset');
    const videoStage = target.closest('[data-video-stage]');
    if (videoStage) return videoStage.querySelector('video');
    return target.closest('img, video');
  };

  const downloadable = (target) => {
    const media = mediaFromTarget(target);
    if (!media || !main.contains(media) || media.classList.contains('placeholder-svg')) return null;
    const bounds = media.getBoundingClientRect();
    if (bounds.width < 110 || bounds.height < 110) return null;
    const url = media.tagName === 'VIDEO' ? videoUrl(media) : imageUrl(media);
    return url ? { media, url } : null;
  };

  const showDownload = (media, url) => {
    if (dialog.open) return;
    const video = media.tagName === 'VIDEO';
    const directUrl = new URL(url.href);
    if (directUrl.pathname.includes('/cdn/') || directUrl.hostname.endsWith('.shopifycdn.com')) {
      directUrl.search += (directUrl.search ? '&' : '?') + 'attachment';
    }
    title.textContent = video ? (strings.saveVideo || 'Guardar video') : (strings.saveImage || 'Guardar imagen');
    download.href = directUrl.href;
    const imageExtension = url.pathname.match(/\.(jpg|jpeg|png|webp|gif|avif)$/i)?.[1]?.toLowerCase() || 'jpg';
    download.download = video ? 'lion-luxury-video.mp4' : `lion-luxury-imagen.${imageExtension}`;
    open.href = url.href;
    dialog.showModal();
    close.focus({ preventScroll: true });
    suppressedHost = media.closest('a, button') || media;
    suppressUntil = performance.now() + 1000;
  };

  document.documentElement.classList.add('media-save-ready');

  document.addEventListener('touchstart', (event) => {
    if (event.touches.length !== 1 || dialog.open) return;
    const selected = downloadable(event.target);
    if (!selected) return;
    cancelPress();
    const touch = event.touches[0];
    press = { id: touch.identifier, x: touch.clientX, y: touch.clientY, fired: false };
    press.timer = window.setTimeout(() => {
      if (!press || press.id !== touch.identifier) return;
      press.timer = 0;
      press.fired = true;
      showDownload(selected.media, selected.url);
    }, 600);
  }, { capture: true, passive: true });

  document.addEventListener('touchmove', (event) => {
    if (!press || event.touches.length !== 1) {
      cancelPress();
      return;
    }
    const touch = event.touches[0];
    if (touch.identifier !== press.id || Math.hypot(touch.clientX - press.x, touch.clientY - press.y) > 12) cancelPress();
  }, { capture: true, passive: true });

  document.addEventListener('touchend', (event) => {
    if (!press || !Array.from(event.changedTouches).some((touch) => touch.identifier === press.id)) return;
    if (press.fired && event.cancelable) event.preventDefault();
    cancelPress();
  }, { capture: true, passive: false });

  document.addEventListener('touchcancel', cancelPress, { capture: true, passive: true });

  window.addEventListener('scroll', cancelPress, { passive: true });

  document.addEventListener('contextmenu', (event) => {
    if (!window.matchMedia('(pointer: coarse)').matches) return;
    const selected = downloadable(event.target);
    if (!selected) return;
    event.preventDefault();
    cancelPress();
    showDownload(selected.media, selected.url);
  }, true);

  document.addEventListener('click', (event) => {
    if (performance.now() > suppressUntil || !suppressedHost) return;
    if (!suppressedHost.contains(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    suppressedHost = undefined;
    suppressUntil = 0;
  }, true);

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog || event.target.closest('[data-media-save-close]')) dialog.close();
    if (event.target.closest('[data-media-save-download], [data-media-save-open]')) {
      window.setTimeout(() => dialog.close(), 120);
    }
  });
})();
